<template>
  <b-row>
    <div class="col-md-6">
      <card class="stacked-form">
        <form v-on:submit.prevent="doSubmit">
          <div>
            <fg-input :required="true" for-input="name" type="text" name="name" id="name" label="Name" placeholder="Enter name" v-validate="modelValidations.name" :error="errors.first('name')" v-model="model.name" data-vv-as="name"/>
            <fg-input v-if="$route.params.id !== undefined" label="Email">
              <p>{{model.email}}</p>
            </fg-input>
            <fg-input v-else :required="$route.params.id === undefined" for-input="email" type="email" name="email" id="email" label="Email" placeholder="Enter email" v-validate="modelValidations.email" :error="errors.first('email')" v-model="model.email" data-vv-as="email"/>
            <div class="form-group" v-bind:class="{ 'has-error': errors.first('password') }">
              <label>Password *</label>
              <input
                class="form-control"
                ref="confirmed:password"
                type="password" name="password" id="password" label="password" placeholder="Enter password" v-validate="modelValidations.password" :error="errors.first('password')" v-model="model.password" data-vv-as="password"
                aria-describedby="addon-right addon-left">
              <slot name="infoBlock"></slot>
              <slot name="helpBlock">
                <div class="text-danger invalid-feedback" style="display: block;" v-if="errors.first('password')">
                  {{ errors.first('password') }}
                </div>
              </slot>
            </div>
            <fg-input :required="$route.params.id === undefined" for-input="passwordConfirmation" type="password" name="passwordConfirmation" id="passwordConfirmation" label="password confirmation" placeholder="Enter Password Confirmation" v-validate="modelValidations.passwordConfirmation" :error="errors.first('passwordConfirmation')" v-model="fakeModel.passwordConfirmation" data-vv-as="password confirmation"/>
            <save-data-button :disabled="saveButtonData.isLoading" :is-create="$route.params.id === undefined" :state="saveButtonData.isLoading && saveButtonData.state === 1 ? 2 : saveButtonData.state" :is-loading="saveButtonData.isLoading"/>
            <cancel-button/>
          </div>
        </form>
      </card>
    </div>
  </b-row>
</template>
<script>
  import { DatePicker, Select, Option, Switch } from 'element-ui'
  import { Radio } from '@/components/index'
  import SaveData from '@/components/Buttons/SaveData'
  import Cancel from '@/components/Buttons/Cancel'

  export default {
    components: {
      SaveDataButton: SaveData,
      CancelButton: Cancel,
      [Option.name]: Option,
      [Select.name]: Select,
      [DatePicker.name]: DatePicker,
      LRadio: Radio,
      LSwitch: Switch
    },
    data () {
      return {
        saveButtonData: {
          isLoading: false,
          state: 1
        },
        apiUrl: {
          profile: window.AppConfig.apiUrl + 'profile'
        },
        model: {
          name: '',
          email: '',
          password: '',
          role: 'gudang'
        },
        fakeModel: {
          passwordConfirmation: ''
        },
        modelValidations: {
          name: {
            required: true
          },
          email: {
            required: true
          },
          password: {
            required: this.$route.params.id === undefined,
            min: 8
          },
          passwordConfirmation: {
            required: this.$route.params.id === undefined,
            confirmed: 'password'
          }
        }
      }
    },
    watch: {
      '$route.params.id': function (val) {
        this.initData()
      }
    },
    mounted () {
      this.initData()
    },
    methods: {
      initData () {
        if (this.$route.params.id !== undefined) {
          this.getDetail()
        }
        setTimeout(() => {
          document.getElementsByName('name')[0].focus()
        }, 100)
      },
      getDetail () {
        this.saveButtonData.isLoading = true
        this.saveButtonData.state = 3
        this.$http.get(this.apiUrl.profile + '/' + this.$route.params.id)
        .then(response => {
          this.model.name = response.data.name
          this.model.email = response.data.email
          this.saveButtonData.isLoading = false
          this.saveButtonData.state = 1
        })
        .catch(error => {
          this.saveButtonData.isLoading = false
          this.saveButtonData.state = 1
          this.$store.dispatch('notification/error', error)
          this.$router.push('/notfound')
        })
      },
      doSubmit () {
        this.$validator.validateAll().then(res => {
          if (res) {
            this.saveButtonData.isLoading = true
            if (this.$route.params.id !== undefined) {
              let model = {}
              Object.keys(this.model).forEach(element => {
                if (element === 'password') {
                  if (this.model.password !== '') {
                    model[element] = this.model[element]
                  }
                } else if (element !== 'email' && element !== 'isActive') {
                  model[element] = this.model[element]
                }
              })
              this.$http.patch(this.apiUrl.profile + '/' + this.$route.params.id, model).then(response => {
                this.saveButtonData.isLoading = false
                this.$store.dispatch('notification/success', 'User has been updated.')
                window.location.href = document.URL.replace('/edit', '')
              }).catch(error => {
                this.saveButtonData.isLoading = false
                this.$store.dispatch('notification/error', error)
              })
            } else {
              this.$http.post(this.apiUrl.profile, this.model).then(response => {
                this.saveButtonData.isLoading = false
                this.$store.dispatch('notification/success', 'User has been added.')
                window.location.href = document.URL.replace('/create', '/' + response.data.id)
              }).catch(error => {
                this.saveButtonData.isLoading = false
                this.$store.dispatch('notification/error', error)
              })
            }
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Settings/Users/Warehouses/Form.vue